import { Link } from "react-router-dom";
import { common } from "includes";
import { Card, Row } from "react-bootstrap";
import ReactApexCharts from "react-apexcharts";
import { ApexOptions } from "apexcharts";

const Incidents = (props: any) => {
  let data: any = props.data;
  let value: [] = data.map((item: any) => item.viewCount);
  let title: [] = data.map((item: any) => item?.title || "Incident");

  const apexOpts: ApexOptions = {
    chart: {
      height: 332,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
      },
    },
    colors: ["#16a7e9"],
    dataLabels: {
      enabled: false,
    },
    series: [
      {
        name: "Views",
        data: value,
      },
    ],
    xaxis: {
      categories: title,
      axisBorder: {
        show: false,
      },
      labels: {
        formatter: function (val: any) {
          return val;
        },
      },
    },
    grid: {
      strokeDashArray: 5,
    },
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h4 className="header-title">Recent Incident Views</h4>
        {/* <Dropdown>
          <Dropdown.Toggle as="a" className="arrow-none card-drop">
            <i className="ri-more-2-fill" />
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item>Refresh Report</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
      </Card.Header>

      <Card.Body className="pt-0">
        <Row>
          <ReactApexCharts
            className="apex-charts"
            options={apexOpts}
            height={350}
            series={apexOpts.series}
            type="bar"
          />
          <div className="table-responsive mt-3">
            <table className="table table-sm mb-0">
              <thead>
                <tr>
                  <th>Incident</th>
                  <th>CreatedOn</th>
                  <th>Views</th>
                </tr>
              </thead>
              <tbody>
                {/* Dynamically render table rows from the data */}
                {data.map((item: any, index: number) => (
                  <tr key={index}>
                    <td>
                      <Link to="#" className="text-muted">
                        {item?.title}
                      </Link>
                    </td>
                    <td>{common.formatDate(item.createdAt, "YYYY-MM-DD HH:mm A", true)}</td>
                    <td>{item.viewCount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Incidents;
